// SQL datetime columns default to sysutcdatetime() but serialize with no zone marker, and
// JavaScript reads a bare date-time as local. Parsing as UTC is what makes both an absolute
// time and an elapsed time come out right.
export function parseUtc(value) {
  if (!value) return null;
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(value);
  const parsed = new Date(hasZone ? value : `${value}Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
